export default __webpack_public_path__ + "static/media/ObjektivMk1_Trial_It.abdc192f.ttf";